import React from 'react'
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs'
import { BlogGridsTitle, BlogTitle } from '../../../../Utils/Constants'
import { Col, Container, Row } from 'reactstrap'
import GridCards from './GridCards'
import LatestNews from './LatestNews'
import BlogSidebar from '../Common/BlogSidebar'

export default function BlogGridsContainer() {
    return (
        <>
            <Breadcrumbs pageTitle={BlogGridsTitle} parent={BlogTitle} title={BlogGridsTitle} />
            <Container className="blog-grid-page" fluid>
                <Row>
                    <Col xxl={9} xl={8} className="box-col-12">
                        <Row>
                            <GridCards/>
                            <LatestNews/>
                        </Row>
                    </Col>
                    <BlogSidebar/>
                </Row>
            </Container>
        </>
    )
}
